// src/components/home/HomeSwarnaprashana.jsx

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import swarnaprashanaImg from "../../assets/images/swarnaprashana_infant.png";

import { supabase } from "../../lib/supabaseClient";

import "./css/HomeSwarnaprashana.css";

const HomeSwarnaprashana = () => {
  const [nextEvent, setNextEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSchedule = async () => {
      const today = new Date();

      today.setHours(0, 0, 0, 0);

      const { data, error } = await supabase
        .from("swarnaprashana_schedule")
        .select("id, date")
        .order("date", { ascending: true });

      if (error) {
        console.error(
          "Error loading Swarnaprashana schedule:",
          error
        );

        setLoading(false);

        return;
      }

      const next = data?.find((item) => {
        const [year, month, day] = item.date.split("-");

        const eventDate = new Date(
          Number(year),
          Number(month) - 1,
          Number(day)
        );

        return eventDate >= today;
      });

      if (next) {
        const [year, month, day] = next.date.split("-");

        const eventDate = new Date(
          Number(year),
          Number(month) - 1,
          Number(day)
        );

        setNextEvent({
          date: eventDate.toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
          }),

          weekday: eventDate.toLocaleDateString("en-IN", {
            weekday: "long",
          }),

          year,
        });
      }

      setLoading(false);
    };

    loadSchedule();
  }, []);

  return (
    <section className="home-swarna">

      <div className="home-container swarna-grid">

        <div className="swarna-image">

          <img
            src={swarnaprashanaImg}
            alt="Swarnaprashana"
          />

        </div>


        <div className="swarna-content">

          <span className="home-section-eyebrow">
            CHILD WELLNESS
          </span>

          <h2>
            Swarnaprashana
            <br />
            <em>Monthly Schedule</em>
          </h2>

          <p>
            A traditional Ayurvedic child wellness practice
            offered according to the monthly Pushya Nakshatra
            schedule at Sudhamshu Ayurveda.
          </p>


          <div className="swarna-date-card">

            <span className="date-label">
              {loading ? "SCHEDULE" : "NEXT SESSION"}
            </span>

            {loading ? (
              <strong>
                Loading...
              </strong>
            ) : nextEvent ? (
              <>
                <strong>
                  {nextEvent.date}
                </strong>

                <span>
                  {nextEvent.weekday} · {nextEvent.year}
                </span>
              </>
            ) : (
              <strong>
                Coming Soon
              </strong>
            )}

          </div>


          <div className="swarna-actions">

            <Link
              to="/contact"
              className="home-button home-button-primary"
            >
              Book a Consultation
            </Link>

            <Link
              to="/services"
              className="home-text-link"
            >
              Learn more
              <span>→</span>
            </Link>

          </div>

        </div>

      </div>

    </section>
  );
};

export default HomeSwarnaprashana;